import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium transition-colors",
  {
    variants: {
      variant: {
        default: "border border-border bg-muted text-foreground",
        success: "border border-success/20 bg-success/10 text-success",
        warning: "border border-warning/20 bg-warning/10 text-warning",
        error: "border border-destructive/20 bg-destructive/10 text-destructive",
        info: "border border-secondary/20 bg-secondary/10 text-secondary",
        primary: "border border-primary/20 bg-primary/10 text-primary",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeVentureProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

const BadgeVenture = React.forwardRef<HTMLSpanElement, BadgeVentureProps>(
  ({ className, variant, ...props }, ref) => {
    return (
      <span ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />
    )
  }
)
BadgeVenture.displayName = "BadgeVenture"

export { BadgeVenture, badgeVariants }
